import { Skeleton, Stack } from "@mui/material";

// Shaped like a list page (title, filters, table), so the layout does not jump when it arrives.
const PageSkeleton = () => (
  <Stack spacing={2} aria-busy="true" sx={{ width: "100%" }}>
    <Skeleton variant="rounded" width={220} height={32} />
    <Skeleton variant="rounded" height={72} />
    <Skeleton variant="rounded" height={420} />
  </Stack>
);

export default PageSkeleton;
